var _path, _path2, _path3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.666 12C19.666 10.5022 19.1856 9.04381 18.2953 7.83928C17.405 6.63474 16.1518 5.74755 14.7198 5.30808C13.2879 4.86861 11.7528 4.90003 10.3401 5.39774C8.92732 5.89544 7.71148 6.83318 6.87122 8.07314C6.03095 9.31309 5.61058 10.7899 5.67188 12.2865C5.73318 13.7831 6.27291 15.2205 7.21176 16.3876C8.15062 17.5547 9.43907 18.3899 10.8878 18.7704C12.3365 19.1509 13.869 19.0566 15.2602 18.5015",
    stroke: "#57606A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.666 12C20.666 11.4477 20.2183 11 19.666 11C19.1137 11 18.666 11.4477 18.666 12H20.666ZM16.666 9C16.666 8.44772 16.2183 8 15.666 8C15.1137 8 14.666 8.44772 14.666 9H16.666ZM18.666 12V13H20.666V12H18.666ZM16.666 13V9H14.666V13H16.666ZM17.666 14C17.1137 14 16.666 13.5523 16.666 13H14.666C14.666 14.6569 16.0092 16 17.666 16V14ZM18.666 13C18.666 13.5523 18.2183 14 17.666 14V16C19.3229 16 20.666 14.6569 20.666 13H18.666Z",
    fill: "#57606A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.666 12C15.666 13.6569 14.3229 15 12.666 15C11.0092 15 9.66602 13.6569 9.66602 12C9.66602 10.3431 11.0092 9 12.666 9C14.3229 9 15.666 10.3431 15.666 12Z",
    stroke: "#57606A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.de34e6897d9abf9fa71d95bf58a752a3.svg";
export { ForwardRef as ReactComponent };